module.exports = __webpack_public_path__ + "img/bj39.91bf6ad8.png";